import { GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import * as i0 from "@angular/core";
import * as i1 from "../../web-generator/generator-env-token";
import * as i2 from "./common-http-client.service";
export class UploadService {
    constructor(generatorEnv, http) {
        this.generatorEnv = generatorEnv;
        this.http = http;
        this.uploadFile2Server = (type, formData) => {
            return this.http.post(`${this.generatorEnv.apiHost}/api/file/upload`, formData, {
                // tslint:disable-next-line: object-literal-key-quotes
                headers: { 'access_token': this.generatorEnv.commonToken },
                params: { type: (type) },
                reportProgress: true,
                observe: 'events'
            });
        };
    }
    getUploadSetting(type) {
        return this.http.get(`${this.generatorEnv.apiHost}/api/file/upload`, {
            // tslint:disable-next-line: object-literal-key-quotes
            headers: { 'access_token': this.generatorEnv.commonToken },
            params: { type: (type) }
        });
    }
    cropImg2Server(cropDetail) {
        return this.http.post(`${this.generatorEnv.apiHost}/api/common/clipped`, cropDetail, {
            headers: { 'access_token': this.generatorEnv.commonToken }
        });
    }
}
UploadService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UploadService_Factory() { return new UploadService(i0.ɵɵinject(i1.GENERATOR_ENV_TOKEN), i0.ɵɵinject(i2.CommonHttpClientService)); }, token: UploadService, providedIn: "root" });
